import { useEffect, useRef, type ReactNode, type RefObject } from 'react';
import { isElement } from 'lodash/fp';
import { useResizeObserver } from 'app/lib/hooks';
import * as styles from './Input.css';

interface ActionsProps {
    children: ReactNode;
    inputRef: RefObject<HTMLInputElement | null>;
}

export function Actions({ children, inputRef }: ActionsProps) {
    const input = inputRef?.current;
    const ref = useRef<HTMLDivElement>(null);
    const { width } = useResizeObserver(ref);

    // Automatically adjust the input's right padding to make room for the
    // actions. This allows multiple buttons or other elements whose width is
    // unknown prior to rendering to be placed in the input. Note that the
    // width provided by the resize observer is only the _content_ width and
    // does not include padding, so we only use this as a trigger to re-run
    // the `useEffect` and instead directly read the `offsetWidth` of the
    // actions to get the correct dimension.
    useEffect(() => {
        if (input && isElement(input) && ref.current) {
            input.style.paddingRight = ref.current.offsetWidth + 'px';
        }
    }, [input, width]);

    return (
        <div ref={ref} className={styles.actions}>
            {children}
        </div>
    );
}
